import { create } from 'zustand'
import { dbgEvent } from '../lib/debug'

export type AgentStatus = 'idle' | 'initializing' | 'active' | 'thinking' | 'aborting' | 'error' | 'closed'

interface StatusStoreState {
  statuses: Record<string, AgentStatus>
  setStatus: (sessionId: string, status: AgentStatus) => void
  getStatus: (sessionId: string) => AgentStatus
}

export const useStatusStore = create<StatusStoreState>((set, get) => ({
  statuses: {},

  setStatus: (sessionId, status) => {
    dbgEvent('Zustand', 'status.setStatus', { sessionId: sessionId.slice(0, 8), status })
    set(state => ({
      statuses: { ...state.statuses, [sessionId]: status },
    }))
  },

  getStatus: (sessionId) => get().statuses[sessionId] ?? 'idle',
}))
